module.exports = __webpack_public_path__ + "img/3f65e2ad777d40c7825b8b676b9df5d5-1440.75ccc3a8.jpg";